import React from 'react';
import { styled } from '@mui/material/styles';
import { Button, ButtonProps } from '@mui/material';
import { addOpacity } from 'lib/helpers';

const StyledButton = styled(Button)(({ theme }) => ({
    height: '40px',
    width: '40px',
    borderRadius: '50%',
    borderColor: addOpacity(theme.palette.text.primary, 0.7),
    color: addOpacity(theme.palette.text.primary, 0.7),
    minWidth: '40px'
}));

export const SplitControlsButton: React.FC<React.PropsWithChildren<ButtonProps>> = ({
    className,
    ...props
}) => <StyledButton variant="outlined" {...props} className={className} />;
